import { ClientAdProductType, CustomerAnalyticsAdspendCategory } from '@zg-rentals/ts-customer-analytics-client';

export const ADVERTISED_PROPERTY_MARKET_MAP_DOT_COLOR = '#0041D9';
export const CLAIMED_PROPERTY_MARKET_MAP_DOT_COLOR = '#73E4F9';
export const TOP_LEAD_VOLUME_PROPERTY_MARKET_MAP_DOT_COLOR = '#0033AB';
export const TOP_LEAD_OPPORTUNITIES_PROPERTY_MARKET_MAP_DOT_COLOR = '#AC001E';
export const SPECIAL_OFFERS_MARKET_MAP_DOT_COLOR = '#C1F7AC';
export const NEW_INVENTORY_ON_ZILLOW_MARKET_MAP_DOT_COLOR = '#196100';
export const NOW_LEASING_MARKET_MAP_DOT_COLOR = '#73E4F9';
export const COMPETITOR_PROPERTY_CHECKED_COLOR = '#21A495';
export const COMPETITOR_PROPERTY_UNCHECKED_COLOR = '#999999';
export const OTHER_ADVERTISING_COLOR = '#ffc752';
export const DARK_ICON_COLOR = '#111116';

export const PACKAGE_COLORS: Record<ClientAdProductType, string> = {
  [ClientAdProductType.BASE_PACKAGE]: '#F08B00',
  [ClientAdProductType.ENHANCED_PACKAGE]: '#21A495',
  [ClientAdProductType.PREMIUM_PACKAGE]: '#3574FF',
  [ClientAdProductType.PREMIUM_PLUS_PACKAGE]: '#0A2472',
  [ClientAdProductType.SIGNATURE_PACKAGE]: '#891EFA',
  [ClientAdProductType.FLAT_FEE_FEED_CONNECT]: '#48CAE4',
  [ClientAdProductType.PAY_PER_LEASE]: '#FF85A1',
  [ClientAdProductType.FLAT_FEE]: '#BC6C25',
  [ClientAdProductType.INTEGRATED_PAY_PER_LEASE]: '#D63384',
  [ClientAdProductType.CONCIERGE_PAY_PER_LEASE]: '#C77DFF',
  [ClientAdProductType.SINGLE_FAMILY]: '#9B2226',
  [ClientAdProductType.SINGLE_FAMILY_DAILY_LISTINGS]: '#FFD60A',
  [ClientAdProductType.SINGLE_FAMILY_FLAT_FEE]: '#343A40',
  [ClientAdProductType.LEASE_UP]: '#80B918',
  [ClientAdProductType.LISTING_SPOTLIGHT]: '#2DC653',
  [ClientAdProductType.PACKAGE_MEDIA_ADD_ON]: '#FF6F61',
  [ClientAdProductType.PAY_PER_CLICK]: '#6D6875',
  [ClientAdProductType.PAY_PER_LEAD]: '#1D3557',
};

export const SPEND_CATEGORY_COLORS: Record<CustomerAnalyticsAdspendCategory, string> = {
  [CustomerAnalyticsAdspendCategory.BASE]: '#F08B00',
  [CustomerAnalyticsAdspendCategory.ENHANCED]: '#21A495',
  [CustomerAnalyticsAdspendCategory.PREMIUM]: '#3574FF',
  [CustomerAnalyticsAdspendCategory.PREMIUM_PLUS]: '#0A2472',
  [CustomerAnalyticsAdspendCategory.SIGNATURE]: '#891EFA',
  [CustomerAnalyticsAdspendCategory.BOOST]: '#E63946',
  [CustomerAnalyticsAdspendCategory.LISTING_SPOTLIGHT]: '#2DC653',
  [CustomerAnalyticsAdspendCategory.FLAT_FEE_FEED_CONNECT]: '#48CAE4',
  [CustomerAnalyticsAdspendCategory.DAILY_FEED_CONNECT]: '#FFD60A',
  [CustomerAnalyticsAdspendCategory.PAY_PER_LEAD]: '#1D3557',
  [CustomerAnalyticsAdspendCategory.PAY_PER_CLICK]: '#6D6875',
  [CustomerAnalyticsAdspendCategory.INTEGRATED_PAY_PER_LEASE]: '#D63384',
  [CustomerAnalyticsAdspendCategory.LEGACY_PAY_PER_LEASE]: '#FF85A1',
  [CustomerAnalyticsAdspendCategory.LEASE_UP]: '#80B918',
  [CustomerAnalyticsAdspendCategory.MEDIA_ADD_ON]: '#FF6F61',
  [CustomerAnalyticsAdspendCategory.MFH_FLAT_FEE]: '#BC6C25',
  [CustomerAnalyticsAdspendCategory.SFH_FLAT_FEE_LEGACY]: '#343A40',
  [CustomerAnalyticsAdspendCategory.SFH_LEGACY]: '#9B2226',
  [CustomerAnalyticsAdspendCategory.WAITLIST]: '#ADB5BD',
};
